import React, { useState, useMemo, useEffect, useRef } from 'react';

const Item = ({ p, onClick }) => {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const o = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setVis(true);
          o.disconnect();
        }
      },
      { rootMargin: '250px' }
    );
    if (ref.current) o.observe(ref.current);
    return () => o.disconnect();
  }, []);

  return (
    <figure
      ref={ref}
      onClick={onClick}
      className="mb-5 sm:mb-7 md:mb-9 break-inside-avoid cursor-pointer group"
      style={vis ? { animation: 'fadeUp .7s both' } : { opacity: 0 }}
    >
      <div className="overflow-hidden bg-paper-dim">
        {vis && (
          <img
            src={p.thumb}
            alt={p.title}
            loading="lazy"
            decoding="async"
            width={p.w}
            height={p.h}
            className="w-full h-auto block transition-transform duration-[1100ms] ease-out group-hover:scale-[1.035]"
          />
        )}
      </div>
      <figcaption className="mt-3 flex items-baseline justify-between gap-4">
        <span className="font-serif italic text-[15px] leading-tight text-ink">{p.title}</span>
        <span className="text-[10px] tracking-[0.12em] uppercase text-muted whitespace-nowrap">
          {[p.city, p.location].filter(Boolean).join(', ')}
        </span>
      </figcaption>
    </figure>
  );
};

const Gallery = ({ photos, onOpen }) => {
  const [filter, setFilter] = useState('Todos');
  const countries = useMemo(
    () => ['Todos', ...Array.from(new Set(photos.map((p) => p.location))).filter(Boolean).sort()],
    [photos]
  );
  const shown = filter === 'Todos' ? photos : photos.filter((p) => p.location === filter);

  return (
    <section id="galeria" className="max-w-[1500px] mx-auto px-4 md:px-10 py-24 md:py-32">
      <div className="text-center mb-12">
        <p className="text-[11px] tracking-[0.42em] uppercase text-muted mb-3">La colección</p>
        <h2 className="font-display font-bold text-4xl md:text-6xl tracking-tight">Galería</h2>
      </div>

      <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-14">
        {countries.map((c) => (
          <button
            key={c}
            onClick={() => setFilter(c)}
            className={`text-[12px] tracking-[0.14em] uppercase pb-0.5 transition-colors ${
              filter === c ? 'text-ink border-b border-ink' : 'text-muted hover:text-ink border-b border-transparent'
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="columns-1 sm:columns-2 lg:columns-3 gap-7 md:gap-9">
        {shown.map((p) => {
          const idx = photos.indexOf(p);
          return <Item key={p.id} p={p} onClick={() => onOpen(idx)} />;
        })}
      </div>
    </section>
  );
};

export default Gallery;
